import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_Staff_DigitalID } from "../shared/data.service";
import { ManualStaffSelectRequest } from "../shared/ManualStaffSelectRequest";
import { StaffRegisterManualEmailRequest } from "../shared/StaffRegisterManualEmailRequest";
import { StaffManualEmailTableComponent } from "./staff-manual-email-table/staff-manual-email-table.component";
import { StaffManualStaffTableComponent } from "./staff-manual-staff-table/staff-manual-staff-table.component";
import { DigitalIdActivationInfoComponent } from "../digital-id-activation-info/digital-id-activation-info.component";
import { CheckValidActivationsRequest } from "../shared/CheckValidActivationsRequest";
import { DialogService } from "primeng/dynamicdialog";

@Component({
	selector: "caass-staff-digital-id-manual-mode",
	templateUrl: "./staff-digital-id-manual-mode.component.html",
	styleUrls: ["./staff-digital-id-manual-mode.component.css"],
})
export class StaffDigitalIdManualModeComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private idService: DataService_Staff_DigitalID, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.loadPersonType();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	@Output() EmailRefresh: EventEmitter<any> = new EventEmitter();

	subscription: any;

	School: any;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "All Schools";

	LoadingPersonType: boolean = true;
	SelectedPersonType: any;
	lstPersonType: any = [];

	LoadingCourse: boolean = true;
	SelectedCourse: any;
	lstCourse: any = [];

	ActiveOptionID: any = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	AlreadyPrintedID: any = -1;
	lstAlreadyPrinted: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Digital ID Printed",
		},
		{
			ID: 0,
			Desc: "Digital ID Not Printed",
		},
	];

	Processing: boolean = false;

	loading: boolean = false;
	lstPerson: any[] = [];
	lstToEmail: any[] = [];

	SelectStaffExpand: boolean = false;
	EmailStaffExpand: boolean = false;

	@ViewChild(StaffManualStaffTableComponent)
	StaffRef: StaffManualStaffTableComponent;

	@ViewChild(StaffManualEmailTableComponent)
	EmailRef: StaffManualEmailTableComponent;

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////

	loadPersonType() {
		this.LoadingPersonType = true;

		var result = this.idService.StaffTypeSelectList(1); //Include instructor
		result.subscribe(
			(response) => {
				this.lstPersonType = response;

				this.lstPersonType.unshift({
					PersonTypeID: -1,
					PersonTypeDesc: "Any",
				});

				this.SelectedPersonType = this.lstPersonType[0];
				this.LoadingPersonType = false;
			},
			(error) => {
				this.LoadingPersonType = false;
			}
		);
	}

	loadCourse() {
		this.LoadingCourse = true;

		var result = this.idService.StaffCourseSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstCourse = response;

				this.lstCourse.unshift({
					CourseDesc: "Any",
				});

				this.SelectedCourse = this.lstCourse[0];
				this.LoadingCourse = false;
			},
			(error) => {
				this.LoadingCourse = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////
	onSearch() {
		this.loading = true;
		this.SelectStaffExpand = true;

		var parms: ManualStaffSelectRequest = {
			SchoolID: this.School.SchoolID,
			PersonTypeID: this.SelectedPersonType.PersonTypeID,
			CourseDesc: this.SelectedCourse.CourseDesc == this.lstCourse[0].CourseDesc ? "" : this.SelectedCourse.CourseDesc,
			Active: this.ActiveOptionID,
			AlreadyPrinted: this.AlreadyPrintedID,
		};

		var result = this.idService.RegisterManualStaffSelectList(parms);
		result.subscribe(
			(response: any) => {
				this.lstPerson = response;

				for (var z = 0; z < this.lstPerson.length; z++) {
					var next = this.lstPerson[z];

					next.Email = "";
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////
	onSchoolChange(school) {
		this.School = school;

		//Load Data
		this.loadCourse();
	}

	onAddToList(lstSelected: any[]) {
		for (var z = 0; z < lstSelected.length; z++) {
			var next = lstSelected[z];

			if (this.lstToEmail.indexOf(next) == -1) {
				this.lstToEmail = [...this.lstToEmail, next];
			}
		}

		this.StaffRef.SelectedPersons = [];

		this.SelectStaffExpand = false;
		this.EmailStaffExpand = true;
	}

	onSendEmail(lstSendEmail: any[]) {
		this.Processing = true;

		var lstPIDs: number[] = [];
		var lstEMs: string[] = [];

		for (var z = 0; z < lstSendEmail.length; z++) {
			var next = lstSendEmail[z];

			if (next.Email != "") {
				lstPIDs = [...lstPIDs, next.PersonID];
				lstEMs = [...lstEMs, next.Email];
			}
		}

		this.CheckValidActivations(lstPIDs, lstEMs);
	}

	CheckValidActivations(lstPIDs: number[], lstEMs: string[]) {
		var parms: CheckValidActivationsRequest = {
			lstPersonIDs: lstPIDs,
		};

		var result = this.idService.EmailCheckValidActivations(parms);
		result.subscribe(
			(response: any) => {
				if (response.length == 0) {
					this.Processing = false;
				} else {
					//All selected schools have enough activations
					if (response[0].AllValid == true) {
						this.FinishEmail(lstPIDs, lstEMs);
					} else {
						var ref = this.dialogService.open(DigitalIdActivationInfoComponent, {
							header: "Not Enough Activations Left",
							width: "fit-content",
							data: {
								//INSERT Custom Data here
								lstTable: response,
							},
						});
						ref.onClose.subscribe((response) => {
							if (response == 1) {
								this.FinishEmail(lstPIDs, lstEMs);
							} else {
								this.Processing = false;
							}
						});
					}
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	FinishEmail(lstPIDs: number[], lstEMs: string[]) {
		var parms: StaffRegisterManualEmailRequest = {
			lstPersonIDs: lstPIDs,
			lstEmails: lstEMs,
		};

		var result = this.idService.RegisterEmail(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				this.lstToEmail = [];
				this.EmailRef.ClearData();
				this.EmailStaffExpand = false;
				this.EmailRefresh.emit(true);
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onRemovePerson(Person) {
		this.lstToEmail = this.lstToEmail.filter((p) => p.PersonID != Person.PersonID);
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingPersonType == true || this.LoadingCourse == true || this.Processing == true;
	}
	///////////////////////////////////////////////////////////////////////////
}
